import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { grid, maxWidthContainer } from '@noths/polaris-client-ribbons-base';

import { PartnerProfile } from './PartnerProfile';
import type { PartnerBlockProps } from './types';
import * as styles from './PartnerBlock.styles';

export const PartnerBlock = ({
  copy,
  currency,
  heading,
  lazyImages,
  onPartnerClick,
  onProductClick,
  onProductVisible = () => {},
  onVisible = () => {},
  partners,
}: PartnerBlockProps) => {
  const partnersRef = useImpressionRef<HTMLElement>(() => onVisible());
  return (
    <section ref={partnersRef}>
      <header css={maxWidthContainer}>
        <h2 css={styles.heading}>{heading}</h2>
        <p css={styles.copy}>{copy}</p>
      </header>
      <div css={styles.partners}>
        <div css={[maxWidthContainer, grid]}>
          {partners.map((partner, partnerIndex) => (
            <PartnerProfile
              currency={currency}
              key={partner.url}
              {...partner}
              lazyImages={lazyImages}
              onPartnerClick={(e) => onPartnerClick?.(e, { partnerIndex })}
              onProductClick={(e, { productIndex }) =>
                onProductClick?.(e, { partnerIndex, productIndex })
              }
              onVisible={() => onProductVisible({ partnerIndex })}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
